import React,{ Component } from 'react';
import { Row, Input } from 'react-materialize';
import GroupSelect from './GroupSelect';
import $ from 'jquery';
import MetricSelect from './MetricSelect';

export default class DataPanel extends Component {
    onChangeGroup1(group){
        this.props.onChangeConfig({group1:group});
    }
    onChangeGroup2(group){
        this.props.onChangeConfig({group2:group});
    }
    onChangeGroup3(group){
        this.props.onChangeConfig({group3:group});
    }
    onChangeMetric1(metric){
        this.props.onChangeConfig({metric1:metric});
    }
    onChangeMetric2(metric){
        this.props.onChangeConfig({metric2:metric});
    }
    onChangeMetric3(metric){
        this.props.onChangeConfig({metric3:metric});
    }
    onChangeChartType(event){
        this.props.onChangeFullRefresh({chartType:event.target.value});
    }
    onChangeDatasource(event){
        this.props.onChangeAttribute({datasource:event.target.value});
    }

    componentDidMount(){
        setTimeout(() => {
            $('.dropdown-content.select-dropdown').css({'min-width':200})
        }, 200)
    }

    supports2ndAttrGroup() {

    }

    componentDidUpdate(){
        setTimeout(() => {
            $('.dropdown-content.select-dropdown').css({'min-width':200})
        }, 200)
    }

    render(){
        return <div className="chart-editor-panel">
            <Row>
                <h6><b>General:</b></h6>
                 <Input 
                    l={12} m={12} s={12} 
                    label="Data source" 
                    defaultValue={this.props.datasource} 
                    onChange={this.onChangeDatasource.bind(this)}/>
                 <Input l={12} m={12} s={12} type="select" label="Chart type" value={this.props.chartStyle} onChange={this.onChangeChartType.bind(this)}>
                    <option value="Area Line">Area Line</option>
                    <option value="Multimetric Area Line">Multimetric Area Line</option>
                    <option value="Bars">Bars</option>
                    <option value="Stacked Bars">Stacked Bars</option>
                    <option value="Clustered Bars">Clustered Bars</option>
                    <option value="Bars and Line">Bars and Line</option>
                    <option value="Multimetric Stacked Bars">Multimetric Stacked Bars</option>
                    <option value="Multimetric Clustered Bars">Multimetric Clustered Bars</option>
                    <option value="Disk">Disk</option>
                    {/* <option value="Word Cloud">Word Cloud</option> */}
                    <option value="Donut">Donut</option>
                    <option value="Trend">Trend</option> 
                    <option value="Multimetric Trend">Multimetric Trend</option> 
                    <option value="Floating Bubbles">Floating Bubbles</option> 
                    {/* <option value="Packed Bubbles">Packed Bubbles</option>  */}
                    <option value="Nested Pie">Nested Pie</option>
                    <option value="Pie">Pie</option>
                    <option value="Radar">Radar</option>
                    <option value="Scatter Plot">Scatter Plot</option>
                    <option value="Tree Map">Tree Map</option>
                    <option value="Tree Map 2D">Tree Map 2D</option>
                </Input>  
            </Row>
            {['Multimetric Trend','Multimetric Area Line'].indexOf(this.props.chartType) == -1 &&
             <Row>
                <GroupSelect
                    title="Group:"
                    value={this.props.group1}
                    attributeList={this.props.attributeList}
                    metricList={this.props.metricList}
                    onChange={this.onChangeGroup1.bind(this)}/>
            </Row>
            }
            {['Trend','Area Line','Multimetric Trend','Multimetric Area Line'].indexOf(this.props.chartType) > -1 &&
                <Row>
                    <GroupSelect
                        title= {['Multimetric Trend','Multimetric Area Line'].indexOf(this.props.chartType) == -1 ? "Group 2:" : "Group:"}
                        value={this.props.group2}
                        attributeList={this.props.timeList}
                        metricList={this.props.metricList}
                        onChange={this.onChangeGroup2.bind(this)}/>
                </Row>
            }
            {['Nested Pie','Tree Map 2D','Stacked Bars','Clustered Bars', 'Floating Bubbles'].indexOf(this.props.chartStyle) > -1 &&
                <Row>
                    <GroupSelect
                        title="Group 2:"
                        value={this.props.group3}
                        attributeList={this.props.attributeList}
                        metricList={this.props.metricList}
                        onChange={this.onChangeGroup3.bind(this)}/>
                </Row>
            }
            <Row>
                <MetricSelect
                    title="Metric:"
                    value={this.props.metric1}
                    metricList={this.props.metricList}
                    onChange={this.onChangeMetric1.bind(this)}/>
            </Row>
            {['Bars and Line', 
                'Multimetric Stacked Bars', 
                'Multimetric Clustered Bars', 
                'Multimetric Trend', 
                'Multimetric Area Line',
                'Scatter Plot',
                'Radar', 
                'Floating Bubbles']
                .indexOf(this.props.chartStyle) > -1 &&
                <Row>
                    <MetricSelect
                        title="Metric 2:"
                        value={this.props.metric2}
                        metricList={this.props.metricList}
                        onChange={this.onChangeMetric2.bind(this)}/>
                </Row>
            }
            {['Scatter Plot','Radar','Multimetric Clustered Bars', 'Multimetric Stacked Bars', 'Multimetric Trend', 'Multimetric Area Line', 'Floating Bubbles'].indexOf(this.props.chartStyle) > -1 &&
                <Row>
                    <MetricSelect
                        title="Metric 3:"
                        value={this.props.metric3}
                        metricList={this.props.metricList}
                        onChange={this.onChangeMetric3.bind(this)}/>
                </Row>
            } 
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/chart-editor/DataPanel.jsx